<template>
    <div class="content">
        <div class="row animated fadeIn">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Sale Tasks</h4>
                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active show" id="active-tab"
                                   data-toggle="tab" href="#activeTasks" role="tab" aria-controls="up" @click="changeTabs('active')">Active</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="resolved-tab" data-toggle="tab"
                                   href="#resolveTasks" role="tab" aria-controls="down" @click="changeTabs('resolved')">Resolved</a>
                            </li>
                          <li class="nav-item">
                                <a class="nav-link" id="resolved-tab" data-toggle="tab"
                                   href="#trafficTab" role="tab" aria-controls="down" @click="changeTabs('traffic')">Traffic</a>
                            </li>
                          <li class="nav-item">
                                <a class="nav-link" id="resolved-tab" data-toggle="tab"
                                   href="#visitors" role="tab" aria-controls="down" @click="changeTabs('visitors')">New Traffic</a>
                            </li>
                          <li class="nav-item" v-if="showSignUpLogs">
                                <a class="nav-link" id="resolved-tab" data-toggle="tab"
                                   href="#signup-logs" role="tab" aria-controls="down" @click="changeTabs('signup-logs')">Signup Logs</a>
                            </li>
                        </ul>
                    </div>
                    <div class="card-body" style="padding-top: 0 !important;">
                        <div class="tab-content customer-table">
                            <div id="activeTasks" class="tab-pane active show" v-if="currentTab === 'active'">
                              <template v-if="!parentLoading">
                                <TaskList :tasks="activeSalesTasks" type="active" tableId="activeSalesTasksTable" />
                              </template>
                              <template v-else>
                                <div class="loader"></div>
                              </template>
                            </div>
                            <div id="resolveTasks" class="tab-pane fade" v-if="currentTab === 'resolved'">
                              <template v-if="!parentLoading">
                                <TaskList :tasks="resolvedSalesTasks" type="resolved" tableId="resolvedSalesTasksTable" @update:tasks="resolvedSalesTasks = $event" />
                              </template>
                              <template v-else>
                                <div class="loader"></div>
                              </template>
                            </div>
                          <div id="trafficTab" class="tab-pane fade" v-if="currentTab === 'traffic'">
                            <template v-if="!parentLoading">
                                <Traffic type="traffic" tableId="traffic" />
                            </template>
                            <template v-else>
                              <div class="loader"></div>
                            </template>
                            </div>
                          <div id="visitors" class="tab-pane fade" v-if="currentTab === 'visitors'">
                            <template v-if="!parentLoading">
                                <Visitors @loadEmailModal="loadEmailModal" type="visitors" tableId="visitors" />
                            </template>
                            <template v-else>
                              <div class="loader"></div>
                            </template>
                          </div>
                          <div id="signup-logs" class="tab-pane fade" v-if="currentTab === 'signup-logs'">
                            <template v-if="!parentLoading">
                                <signup-logs />
                            </template>
                            <template v-else>
                              <div class="loader"></div>
                            </template>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      <ManualTask task="Manual Tasks" type="sales"/>
      <div class="email-log-modal">
        <div class="modal" tabindex="-1" role="dialog" id="emailModal">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h6 class="modal-title">Email For Traffic Overage</h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <legend class="col-form-label">Send Email To:
                  </legend>
                  <div  class="row pl-15 pr-15 mt-10">
                    <div class="col-md-4 form-check-radio">
                      <label class="form-check-label">
                        <input class="form-check-input" v-model="selectedOption" type="radio" id="inputDomain" value="test"> Test Email
                        <span class="form-check-sign"></span>
                      </label>
                    </div>
                    <div class="col-md-6 form-check-radio">
                      <label class="form-check-label">
                        <input class="form-check-input" v-model="selectedOption" type="radio" id="status" value="client"> Client Email
                        <span class="form-check-sign"></span>
                      </label>
                    </div>
                  </div>
                  <div v-if="selectedOption === 'test'" class="form-group">
                    <label>Test Email</label>
                    <input v-model="email.emailTo" class="form-control" type="text">
                  </div>
                </div>
                <button class="btn btn-outline-info btn-sm pull-right" :disabled="syncLoading"  @click="sendEmail">
                  <div class="loader mini_loader" v-if="syncLoading"></div>
                  <span v-else>Submit</span>
                </button>
              </div>
              <div v-if="email.history && email.history.length" class="pl-50 pr-50 pb-50">
                <h5 class="text-center">Email History</h5>
                <perfect-scrollbar style="position:relative; height: 400px">
                  <table class="table table-bordered table-striped">
                    <thead class="th-light">
                    <th class="text-center">Traffic Stats</th>
                    <th class="text-center">Date</th>
                    <th class="text-center">Preview</th>
                    </thead>
                    <tbody>
                    <tr :key="index" v-for="(row, index) in sortedEmailHistory">
                      <td class="">
                        <div class="text-center fw-600">Total: {{ row.trafficData ? row.trafficData.total : '0' }}</div>
                        <div class="row">
                          <div class="col-md-7">
                            <div class="fw-600 text-center">Bots</div>
                            <div class="ml-50 d-flex align-items-center"><i class="fa fa-circle mr-5" style="font-size: 10px; color: #88a0e5"></i>Good Bots: {{ row.trafficData ? row.trafficData.goodBots : '0' }}</div>
                            <div class="ml-50 d-flex align-items-center"><i class="fa fa-circle mr-5" style="font-size: 10px; color: #d21717"></i>Bad Bots: {{ row.trafficData ? row.trafficData.badBots : '0' }}</div>
                            <div class="ml-50 d-flex align-items-center"><i class="fa fa-circle mr-5" style="font-size: 10px; color: #daa270"></i>Malicious Bots: {{ row.trafficData ? row.trafficData.maliciousBots : '0' }}</div>
                          </div>
                          <div class="col-md-5 text-center">
                            <span class="fw-600">Billable</span>
                            <div class=" d-flex align-items-center"><i class="fa fa-circle mr-5" style="font-size: 10px; color: #00a84d"></i> Unique Visits: {{ row.trafficData ? row.trafficData.uniqueVisits : '0' }}</div>
                          </div>
                        </div>
                      </td>
                      <td class="text-center">{{ formatDate(row.createdAt) }}</td>
                      <td class="text-center make-cursor-pointer text-primary"><i @click="previewHtml(row.previewEmailUrl)" class="fa fa-eye"></i></td>
                    </tr>
                    </tbody>
                  </table>
                </perfect-scrollbar>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-default btn-sm" data-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
    import TempLinks from "@/components/Admin/Tools/tempLinks.vue";
    import ManualTask from "@/components/Admin/Sales/ManualTask.vue";
    import signupLogs from "@/components/Admin/Tools/signupLogs.vue";
    import salesTaskMixin from "@/mixins/salesTaskMixin";
    import swal from "sweetalert2";
    import {auth, db} from "@/firebase/init";
    import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
    import moment from 'moment';
    export default {
        name: "TasksView",
        components: {
          PerfectScrollbar,
          ManualTask,
          signupLogs,
          TempLinks,
            TaskList: () => import(/* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Tasks/TaskList.vue"),
            Traffic: () => import(/* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Tasks/Traffic.vue"),
            Visitors: () => import(/* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Tasks/Visitors.vue"),
        },
       mixins: [salesTaskMixin],
        data () {
            return {
              initTables: false,
              currentTab: 'active',
              parentLoading: true,
              email: {sendTo: 'test', history: []},
              selectedOption: '',
              syncLoading: false,
              selectedRole: ['admin', 'super-admin'],
            }
        },
      computed: {
        sortedEmailHistory() {
          return this.email.history.sort(
              (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
        },
        showSignUpLogs () {
          return this.selectedRole.includes(this.user.userType)
        },
        user() {
          return this.$store.getters.user;
        }
      },
        async mounted() {
          await this.fetchActiveSalesTasksSnapShot()
          setTimeout(()=>{
            this.parentLoading = false
          }, 500)
        },
        watch: {
            activeSalesTasks (value) {
              if(value){
                $(`#activeSalesTasksTable`).DataTable().destroy();
                setTimeout(()=>{
                  this.initSupportTasksTable('activeSalesTasksTable')
                }, 500)
              }
            },
        },
        methods: {
          previewHtml(url) {
            window.open(url, '_blank')
          },
          formatDate(date) {
            return moment(date).format('DD MMM YYYY hh:mm A')
          },
          async sendEmail() {
            try {
              console.log(`emil data ${this.email}`)
              this.syncLoading = true
              const response = await this.$http.post('/traffic/send-email-for-over-traffic', {
                grant_type: 'token',
                message: '',
                subject: '',
                trafficData: {
                  "goodBots": this.email.totalGoodBots,
                  "badBots": this.email.totalBadBots,
                  "maliciousBots": this.email.totalMaliciousBots,
                  "uniqueVisits": this.email.billable,
                  "total": this.email.totalVisitors
                },
                isEmailForClient: true,
                name: this.email.name,
                emailTo: this.selectedOption === 'test' ? this.email.emailTo : this.email.email
              });
              console.log(`response from api ${response.data}`)
              swal('Success', 'You have successfully sent email!', 'success')
            } catch (e) {
              swal('Error', 'Something went wrong while sending email!', 'error')
            } finally {
              if(this.selectedOption === 'client') {
                this.email = { sendTo: 'test' };
                $('#emailModal').modal('hide');
              }
            }
            this.syncLoading = false
          },
          async loadEmailModal(data) {
            this.email = JSON.parse(JSON.stringify(data));
            this.selectedOption = 'test'
            console.log(`email ${JSON.stringify(this.email)}`)
            $('#emailModal').modal('show');
            $('.modal-backdrop').removeClass("modal-backdrop");
          },
          async changeTabs(tabValue){
            if (tabValue === this.currentTab) {
              return false;
            }
            this.currentTab = tabValue;
            await this.setTabs()
            },
          async setTabs(){
              this.reInitDataTable()
              switch (this.currentTab) {
                case 'active': {
                  this.parentLoading = true
                  await this.fetchActiveSalesTasksSnapShot()
                  this.destroyPreviousSnapShots(this.currentTab)
                  setTimeout(()=>{
                    this.parentLoading = false
                  }, 500)
                  break;
                }
                case 'resolved': {
                  this.parentLoading = true
                  await this.fetchResolvedSalesTasks()
                  this.destroyPreviousSnapShots(this.currentTab)
                  setTimeout(()=>{
                    this.parentLoading = false
                  }, 500)
                  break;
                }
                case 'traffic' : {
                  break;
                }
                case 'visitors' : {
                  break;
                }
                default: {
                  console.log('Switched to another tab');
                  break;
                }
            }
          },
            reInitDataTable(){
                /* eslint-disable */
                $(`#activeSalesTasksTable`).DataTable().destroy();
                $(`#resolvedSalesTasksTable`).DataTable().destroy();
                /* eslint-enable */
                this.initTables = true;
            },
            initSupportTasksTable(el) {
                console.log('Loading datatable');
                /* eslint-disable */
                // if($.fn.DataTable.isDataTable( `#${el}` )){
                // 	$(`#${el}`).DataTable().destroy();
                // }
              $(`#${el}`).DataTable({
                pagingType: "full_numbers",
                lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
                destroy: true,
                retrieve: true,
                deferRender: true,
                "ordering": false,
                stateSave: true,
                language: {
                  search: "_INPUT_",
                  searchPlaceholder: "Search Task",
                  size: 50
                }
              });
                /* eslint-enable */
            },
            destroyPreviousSnapShots(ignoreSnapShot){
              const snapShots = {
                'active' : this.activeSalesTaskListener,
              };
              let snapShotKeys = Object.keys(snapShots);
              snapShotKeys = snapShotKeys.filter((value)=> value !== ignoreSnapShot);
              for (const snapShot of snapShotKeys){
                if(snapShots[snapShot]){
                  console.log('destroyed this one', snapShot)
                  snapShots[snapShot]()
                }
              }
            },
        },

        destroyed() {
            console.log('Detaching  sales tasks listeners on admin side...');
            this.destroyPreviousSnapShots('all')
            this.$store.dispatch('tasks/resetResolvedSalesListener');
        }
    }
</script>

<style scoped>
::v-deep .dataTables_wrapper .dataTables_filter input::-webkit-search-cancel-button {
  -webkit-appearance: button !important;
}
    .nav-tabs .nav-item .nav-link.active:before,
    .nav-tabs .nav-item .nav-link.active:hover:before,
    .nav-tabs .nav-item .nav-link.active:focus:before {
        border: 0;
    }

    .nav-tabs {
        border-bottom: 1px solid #dee2e6;
    }

    .nav-tabs .nav-link {
        border: 1px solid transparent !important;
        border-top-left-radius: .25rem;
        border-top-right-radius: .25rem;
    }

    .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
        color: #495057;
        background-color: #fff;
        border-color: #dee2e6 #dee2e6 #fff !important;
    }

    .nav-tabs .nav-item .nav-link.active {
        color: #5B7CFB;
    }
</style>
